/**
 * Table Designer Feature Module
 *
 * Buffer-backed Designer (VqeDdlEdit Slice 0.5): the visual UI consumes the
 * `visual-ddl-editor/render/table/` components, the hidden Monaco-like buffer
 * holds the CREATE TABLE source, and Save runs the buffered diff through the
 * engine-agnostic execute pipeline.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the table-designer workspace component
registerWorkspaceComponent(
  'table-designer',
  lazyWorkspaceTab(() => import('./components/TableDesignerTab').then((m) => ({ default: m.TableDesignerTab }))),
);

// Re-export components
export { TableDesignerDialog } from './components/TableDesignerDialog';
export { TableDesignerToolbar } from './components/TableDesignerToolbar';
export { TableDesignerSqlView } from './components/TableDesignerSqlView';

// Re-export hooks
export { useDesignerBuffer } from './hooks/useDesignerBuffer';

// Re-export services
export {
  synthesizeBlankCreateTable,
  synthesizeCreateFromMetadata,
  synthesizeAlterTableBuffer,
} from './services/synthesizeBuffer';
export type { SynthesizeCreateContext, SynthesizeAlterContext } from './services/synthesizeBuffer';

export {
  hasBufferChanges,
  splitStatements,
  containsDestructiveOps,
  executeBufferedDdl,
} from './services/saveChanges';
export type { SaveChangesContext, SaveChangesResult } from './services/saveChanges';
